import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
/**
 * Quick Shop methods
 * -----------------------------------------------------------------------------
 *
 * @namespace quickShop
 */

import axios from 'axios';
import detectIt from 'detect-it';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';

var quickShopMethods = {
  data: function data() {
    return {
      quickShop: {
        isQuickshopModalOpen: false,
        currentVariant: {},
        product: {},
        images: {},
        optionImages: {},
        metafields: {}
      }
    };
  },


  methods: {
    /**
     * Adds a variant from wishlist Array
     * @param  {productHandle}
     *
     */
    _viewQuickShop: function _viewQuickShop(productHandle, selectedOptions, event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var $modal, $modalBody, $qtyEl, $carousel, carouselOptions, flktyMain, cellElements, productId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(productHandle, selectedOptions, event);
                $modal = $('[data-template="quickshop"]');
                $modalBody = $modal.find('.modal-body');
                $qtyEl = $modal.find(app.selectors.qtyInput);
                $carousel = void 0;
                carouselOptions = void 0;
                flktyMain = void 0;
                cellElements = void 0;
                productId = void 0;

                app.isLoading = true;

                // get product main data
                if ($modal.find('.wishlisthero-quick-view').length > 0) {
                  $modal.find('.wishlisthero-quick-view').remove();
                }

                _context.next = 13;
                return axios.get('/products/' + productHandle + '.js').then(function (response) {
                  app.quickShop.product = response.data;
                  app.quickShop.images = response.data.images;
                  productId = response.data.id;
                  return response;
                }).catch(function (error) {
                  console.log(error);
                  Rollbar.critical('Filename: QuickShop.js, Error occurs while _viewQuickShop event: ' + error);
                  throw error;
                });

              case 13:
                _context.next = 15;
                return axios.get('/products/' + productHandle + '?view=json').then(function (response) {
                  app.isLoading = false;

                  app.quickShop.optionImages = response.data.option_images;

                  // assign the product cart limit
                  app.quickShop.product.cart_limit = null;

                  if (app.quickShop.product.tags) {
                    app.quickShop.product.tags.forEach(function (tag) {
                      if (tag.match('cart-limit')) {
                        var cartLimit = tag.replace('cart-limit-', '');
                        app.quickShop.product.cart_limit = parseFloat(cartLimit);
                      }
                    });
                  }

                  $modal.on('shown.bs.modal', function (e) {

                    app.isQuickshopModalOpen = true;
                    $carousel = $(this).find('[data-flickity]');

                    // re-init tooltips but only for desktop
                    if (!detectIt.hasTouch) {
                      $('[data-toggle="tooltip"]').tooltip();
                    }

                    if ($carousel.length > 0) {
                      carouselOptions = $carousel.data('flickity');
                      flktyMain = new Flickity($carousel[0], carouselOptions);
                      cellElements = flktyMain.getCellElements();
                      flktyMain.resize();
                    }

                    if (!selectedOptions) {
                      selectedOptions = app.quickShop.product.variants[0].options;
                    }

                    selectedOptions.forEach(function (option) {
                      $('[data-template="quickshop"] input[value="' + option + '"]').trigger('click');
                      $('[data-template="quickshop"] option[value="' + option + '"]').prop('selected', true);
                    });

                    setTimeout(function () {
                      app._getVariant(event);
                    }, 100);

                    setTimeout(function () {
                      // attach Recharge widget
                      // if (app.quickShop.metafields.subscriptions) {
                      //   app._attachRechargeWidget(productId);
                      // }
                      // open modal
                      $modalBody.addClass('opened');
                    }, 400);
                  });

                  $modal.on('hidden.bs.modal', function (e) {
                    // resets
                    $qtyEl.val(1); // reset qty input to 1
                    app.quickShop.product = {};
                    app.quickShop.images = {};
                    app.quickShop.currentVariant = {};
                    app.reChargeDiscountVariantId = null;
                    app.isQuickshopModalOpen = false;
                    $modalBody.removeClass('opened');

                    // detach Recharge widget
                    // if (app.quickShop.metafields.subscriptions) {
                    //   app._detachRechargeWidget(productId);
                    //   app.quickShop.metafields.subscriptions = {};
                    // }

                    // destroy carousel if exists
                    if ($carousel.length > 0) {
                      flktyMain.destroy();
                    }
                  });

                  $modal.modal('show');

                  setTimeout(function () {
                    var buttonDiv = document.createElement('div');
                    buttonDiv.classList.add('wishlisthero-quick-view');
                    buttonDiv.setAttribute('data-wlh-id', app.quickShop.product.id);
                    buttonDiv.setAttribute('data-wlh-link', app.quickShop.product.url);
                    buttonDiv.setAttribute('data-wlh-variantId', app.quickShop.currentVariant.id);
                    buttonDiv.setAttribute('data-wlh-price', app.quickShop.currentVariant.price / 100);
                    buttonDiv.setAttribute('data-wlh-name', app.quickShop.currentVariant.name);
                    buttonDiv.setAttribute('data-wlh-image', app.quickShop.product.featured_image);
                    buttonDiv.setAttribute('data-wlh-mode', 'wishlisthero-floating');
                    $modal.find('.quick-parent').append(buttonDiv);

                    // init buttonf or wishlist
                    var ev = new CustomEvent('wishlist-hero-add-to-custom-element', {
                      detail: buttonDiv
                    });
                    document.dispatchEvent(ev);
                  }, 1500);

                  return response;
                }).catch(function (error) {
                  // console.log(error);
                  Rollbar.error('Filename: QuickShop.js, Error occurs while _viewQuickShop event: ' + error);
                  throw error;
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

export default quickShopMethods;